import { HttpService } from '@/shared/services'
import Payroll from '../models/Payroll'

const http = new HttpService()

interface createPayrollsInfo {
  configId: string
  payrolls: Payroll[]
}

export const createPayrolls = async (
  createPayrollsInput: createPayrollsInfo
) => {
  const response = await http.post<createPayrollsInfo, string>(
    'payroll',
    createPayrollsInput
  )
  return response.data
}

export const getPayrollsByConfigId = async (configId: string) => {
  const response = await http.get<Payroll[]>(`payroll/config/${configId}`)
  return response.data
}

export const getPayrollsByCompanyId = async (companyId: string) => {
  const response = await http.get<Payroll[]>(`payroll/${companyId}`)
  return response.data
}
